<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box">
          <!-- /.box-header -->
          <div class="box-body form-center">
            <br />
            <div class="text-center">
              <img :src="info.image_name" class="img-store-info">
              <br />
            </div>
            <div class="text-right">
              <router-link :to="{path: '/upBrand/' + info.id}"><button class="btn btn-primary inherit"><i class="fa fa-pencil" aria-hidden="true"></i></button></router-link>
              <br />
            </div>
          </div>
          <div class="box-body form-left">
            <div>
              <div class="input-group ">
                <span class="input-group-addon">名稱 (ID)</span>
                <div class="form-control form-info">
                  {{info.name}} ({{info.id}})
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group ">
                <span class="input-group-addon">名稱縮寫</span>
                <div class="form-control form-info">
                  {{info.name_short}}
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group ">
                <span class="input-group-addon">名稱別名</span>
                <div class="form-control form-info">
                  {{ nameAliasDisplay }}
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">代碼(鍵值)</span>
                <div class="form-control form-info">
                  {{info.brand_code}} ({{info.brand_key}})
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">排序</span>
                <div class="form-control form-info">
                  {{info.sort}}
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  標語
                </span>
                <div class="form-control form-info">
                  {{info.slogan}}
                </div>
              </div>
              <br />
            </div>
            <div v-if="info.comment">
              <div class="input-group">
                <span class="input-group-addon">
                  訊息
                </span>
                <div class="form-control form-info">
                  {{info.comment}}
                </div>
              </div>
              <br />
            </div>
            <div v-if="info.description">
              <div class="input-group">
                <span class="input-group-addon">
                  描述
                </span>
                <div class="form-control form-info">
                  {{info.description}}
                </div>
              </div>
              <br />
            </div>
            <div v-if="info.introduction">
              <div class="input-group">
                <span class="input-group-addon">
                  品牌頁介紹
                </span>
                <div class="form-control form-info">
                  {{info.introduction}}
                </div>
              </div>
              <br />
            </div>
            <div v-if="info.email">
              <div class="input-group">
                <span class="input-group-addon">
                  信箱
                </span>
                <div class="form-control form-info">
                  {{info.email}}
                </div>
              </div>
              <br />
            </div>
            <div v-if="info.youtube_video_code">
              <div class="input-group">
                <span class="input-group-addon">
                  Youtube影片代碼
                </span>
                <div class="form-control form-info">
                  {{info.youtube_video_code}}
                </div>
              </div>
              <br />
            </div>
          </div>
          <div class="box-body form-left">
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  品牌上架
                </span>
                <div class="form-control form-info">
                  <span class="label label-danger" v-if="!info.is_opening">未上架</span>
                  <span class="label label-success" v-if="info.is_opening">已上架</span>
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  前端顯示
                </span>
                <div class="form-control form-info">
                  <span class="label label-danger" v-if="!info.is_visible">未顯示</span>
                  <span class="label label-success" v-if="info.is_visible">顯示</span>
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  刪除
                </span>
                <div class="form-control form-info">
                  <span class="label label-danger" v-if="info.is_delete">刪除</span>
                  <span class="label label-success" v-if="!info.is_delete">未刪除</span>
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">最後更新時間</span>
                <div class="form-control form-info">
                  {{info.edit_time}}
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">建立時間</span>
                <div class="form-control form-info">
                  {{info.create_time}}
                </div>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">聯名圖</span>
                <div class="form-control form-info">
                  <img :src="info.logo_name" style="max-height: 50px">
                </div>
              </div>
              <br />
            </div>
            <div v-if="info.photo_name">
              <div class="input-group">
                <span class="input-group-addon">底圖</span>
                <div class="form-control form-info">
                  <img :src="info.photo_name" style="max-height: 100px">
                </div>
              </div>
              <br />
            </div>
            <div v-if="info.meal_tag_setting.length">
              <div class="input-group">
                <span class="input-group-addon">
                  餐點種類
                </span>
                <div class="form-control form-info">
                  <span class="label label-success m-b-5 m-r-5" v-for="mealSetting in info.meal_tag_setting">{{mealSetting.name}}</span>
                </div>
              </div>
              <br />
            </div>
          </div>
          <div class="box-body form-center" v-if="info.website_setting.length">
            <hr>
            <br>
            <div class="row">
              <div class="col-sm-12 table-responsive p-x-0">
                <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
                  <thead>
                  <tr role="row">
                    <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">資訊</th>
                    <th colspan="1" rowspan="1" aria-controls="example" tabindex="0" class="">連結</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="even" role="row" v-for="(setting, index) in info.website_setting">
                    <td>
                      {{setting.name}}
                    </td>
                    <td>
                      <a :href="setting.url" target="_blank">{{setting.url}}</a>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data () {
    return {
      info: {
        website_setting: [],
        meal_tag_setting: [],
        name_alias: []
      }
    }
  },
  methods: {
    getBrandInfo () {
      var self = this
      var url = '/brand/' + this.$route.params.brand_id
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.info = response.data.brand_info
        }
      })
    }
  },
  created () {
    this.getBrandInfo()
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    },
    nameAliasDisplay () {
      if (!this.info.name_alias || !Array.isArray(this.info.name_alias)) {
        return ''
      }
      return this.info.name_alias.map(alias => {
        if (typeof alias === 'object' && alias !== null) {
          return alias.label || alias.value || alias
        }
        return alias
      }).join('、')
    }
  }
}
</script>



// WEBPACK FOOTER //
// BrandInfo.vue?31d584f5